export const DD_USE_CASES = {
    GLOBAL: 'GLOBAL',
    HOMEPAGE: 'HOMEPAGE',
    NOTIFICATION: 'NOTIFICATION',
    RM_GAME: 'RM_GAME',
    RM_EXIT_SCREEN: 'RM_EXIT_SCREEN',
    GAME_LAUNCHER: 'GAME_LAUNCHER',
    PROMOTIONPAGE: 'PROMOTIONPAGE',
    CAROUSEL: 'CAROUSEL',
    SITE_WIDE_JACKPOT: 'SITE_WIDE_JACKPOT',
    SESSION: 'SESSION',
    GENEROSITY_RETRY: 'GENEROSITY_RETRY',
    STREAMING: 'STREAMING'
} as const;

export type IddUseCases = keyof typeof DD_USE_CASES;

type TRumBase = {
    name: string;
    description: string;
    use_case: IddUseCases;
};

export type TRumAction = TRumBase & {
    context?: Record<string, unknown> | unknown[];
};

export type TRumError = TRumBase & {
    context?: Record<string, unknown> | unknown[];
    stack?: string | Error;
};
